import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "../components/ui";
import Countdown from "../components/common/Countdown";
import RegisterForm from "../components/user-profile-lite/RegisterForm";
import { analysts } from "../views/LandingPage/analystsJson";
import Carousel from "../components/common/Carousel";
import { Modal, ModalHeader, ModalBody } from "../components/ui";
import introVideoIcon from "../../src/images/bitcoin-live/Intro_Vid_Icon.png";
import TwitterIcon from "../../src/images/bitcoin-live/TwitterIcon.png";
import "../views/LandingPage/styles.scss";

const scrollUp = () => {
  window.scrollTo(0, 0);
};

const galleryBreakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 850, itemsToShow: 3 },
  { width: 1150, itemsToShow: 3 },
  { width: 1450, itemsToShow: 3.1 },
  { width: 1500, itemsToShow: 4.1 },
  { width: 1600, itemsToShow: 4.1 },
  { width: 2000, itemsToShow: 5.1 },
];

const Terms = () => {
  const [url, setUrl] = useState("");
  const [modal, setModal] = useState(false);
  return (
    <Container
      style={{
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 50,
        maxWidth: "100%",
        overflowX: "hidden",
        background: "#f5f6f8",
      }}
      id="promo-sale"
    >
      <Row>
        <Col
          lg={12}
          style={{
            paddingBottom: 20,
            paddingTop: 20,
            justifyContent: "center",
            width: "100%",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              color: "red",
              fontWeight: "bold",
              letterSpacing: "3.5px",
              lineHeight: window.screen.width < 500 ? "70px" : {},
            }}
          >
            Bitcoin Live 7th Anniversary Week Sale!
          </h1>
          <br />
          <br />
          <h2
            style={{ color: "red", fontWeight: "bold", letterSpacing: "3.5px" }}
          >
            Sale Ends In
          </h2>
          <br />
          <div style={{ color: "red" }}>
            <Countdown />
          </div>
          <h2 style={style.heading}>
            The most trusted and established Crypto educational service.
            <br /> We're celebrating 7 Years of providing responsible and expert
            guidance from a group
            <br /> of veteran and experienced traders.
          </h2>
        </Col>
      </Row>
      <div style={{ width: "100%", height: "100%" }} className="parentDiv">
        <Carousel
          transitionMs={2000}
          breakPoints={galleryBreakPoints}
          pagination={false}
        >
          {analysts.map((data) => (
            <div style={{ marginTop: 20, color: "#212529" }}>
              <img className="profileImg" src={data.profilePic} alt="profile" />
              <div className="analystDiv">
                <div style={{ marginTop: 110 }}>
                  <label className="name">
                    {data.name}{" "}
                    <a href={data.twitterUrl} target="_blank" rel="noreferrer">
                      <img src={TwitterIcon} alt="icon" />
                    </a>
                  </label>
                  <ul
                    style={{
                      lineHeight: "35px",
                      opacity: "0.7",
                      marginTop: 10,
                    }}
                  >
                    {data.content.map((item) => (
                      <li>{item}</li>
                    ))}
                  </ul>
                  {data.introVideo && (
                    <label
                      onClick={() => {
                        setModal(true);
                        setUrl(data.introVideo);
                      }}
                      className="introLabel"
                      style={{ left: data.name === "Big Cheds" ? "0px" : {} }}
                    >
                      watch {data.name}'s intro{" "}
                      <img src={introVideoIcon} alt="icon" />
                    </label>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
      <Modal
        centered={true}
        size="md"
        isOpen={modal}
        toggle={() => {
          setModal(false);
        }}
        style={{
          background: "#fff",
          minWidth: window.screen.width > 500 ? "684px" : "auto",
          minHeight: window.screen.width > 500 ? "50%" : "220px",
          position: "relative",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        <ModalHeader
          toggle={() => {
            setModal(false);
          }}
          style={{ border: "none" }}
        ></ModalHeader>
        <ModalBody
          style={{ minHeight: window.screen.width > 500 ? "560px" : "auto" }}
        >
          <div style={{ height: window.screen.width > 500 ? "auto" : "220px" }}>
            <div
              style={{ height: window.screen.width > 500 ? {} : "160px" }}
              className={`wistia_embed wistia_async_${url}`}
            ></div>
          </div>
        </ModalBody>
      </Modal>
      <Row style={{ paddingBottom: "20px" }}>
        <Col sm={{ size: 5, offset: 1 }}>
          <div
            style={{
              height: "250px",
              marginTop: "20%",
              outline: "black",
              outlineStyle: "solid",
              outlineWidth: "1px",
            }}
            className={"wistia_embed wistia_async_fwaxun2z59"}
          ></div>
        </Col>
        <Col sm={{ size: 5 }} className="mx-3">
          <h5 style={style.title}>
            Bitcoin Live: Transform Your Passion Into Trading Profits
          </h5>
          <p style={style.content}>
            New to cryptocurrency or trading? Or already in the game but want to
            know how to transform your passion into greater success and results?
            No worries, Bitcoin Live is here to help you take your crypto
            trading to the next level with a host of features, services, and
            resources, including:
          </p>
          <ul style={style.content}>
            <li>Real-Time Trade Alert Ideas</li>
            <li>Technical Analysis Training</li>
            <li>Live Events with World's Leading Crypto Traders</li>
            <li>Intuitive Learning Platform</li>
            <li>Chats, Alerts, Webinars, and Reports</li>
          </ul>
        </Col>
      </Row>
      <Row
        style={{
          marginBottom: -10,
          paddingTop: 20,
          justifyContent: "center",
          width: "100%",
          textAlign: "center",
        }}
      >
        <h4 style={{ color: "red", fontWeight: "bold", lineHeight: "40px" }}>
          Bitcoin Live 7th Anniversary Week Sale!
          <br />
          {/* For a limited time, save 50% on your payment towards a quarterly (3
          month) membership. Pay only $148 total today for three months full
          access. */}
          For a limited time, you get $200 off, pay just $97 today for three
          months full access.
        </h4>
        <span style={{ fontSize: "16px", width: "100%" }}>
          (Auto Renews at regular rate of $297)
        </span>
        <p style={style.contentBottom}>
          Let Bitcoin Live's Analysis Help You Navigate through the next Crypto
          Bull Market and prepare you for the opportunity. How you perform and
          execute over this period will be critical to your success.
        </p>
      </Row>
      <Row style={{ paddingBottom: 40 }}>
        <div className="arrows">
          <div className="arrow_down"></div>
          <div className="arrow_down"></div>
          <div className="arrow_down"></div>
        </div>
      </Row>
      <Row style={{ justifyContent: "center" }}>
        <h2
          style={{
            color: "black",
            fontWeight: "bold",
            textAlign: "center",
            width: "100%",
            paddingBottom: "15px",
          }}
        >
          Checkout Form
        </h2>
        <br />
        <br />
        <RegisterForm planId={4} coupon="" />
      </Row>
      {scrollUp()}
    </Container>
  );
};

Terms.propTypes = {
  smallStats: PropTypes.array,
};

const style = {
  title: {
    fontWeight: 500,
    fontSize: "20px",
    fontHeight: "35px",
    color: "#29293A",
    paddingTop: 24,
    lineHeight: "45px",
    paddingBottom: 30,
  },
  heading: {
    lineHeight: "3rem",
    fontSize: "1.4rem",
    fontWeight: "600",
    color: "#000000",
    textAlign: "center",
    margin: "2.2rem 0 0 0",
  },
  content: {
    lineHeight: "2rem",
    fontSize: "1rem",
    color: "#000000",
    fontWeight: "bold",
  },
  contentBottom: {
    lineHeight: "2rem",
    fontSize: "1rem",
    color: "#000000",
    fontWeight: "bold",
    paddingTop: "20px",
    marginRight: "10px",
  },
};

export default Terms;
